module.exports = __webpack_public_path__ + "static/media/screenshot-1.00c66fa5.png";